import { PureComponent } from "react";

class CustomizedAxisTick extends PureComponent {
  render() {
    const { x, y, payload } = this.props;

    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={0}
          y={0}
          dy={16}
          textAnchor="end"
          fill="#666"
          transform="rotate(-60)"
        >
          {payload.value}
        </text>
      </g>
    );
  }
}

export default CustomizedAxisTick;
